module.exports = __webpack_public_path__ + "img/lg_ring_g_i_1_0@2x.101c01d9.png";